module.exports = __webpack_public_path__ + "assets/img/img82.7c5c8fb4.png";